import { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import Api from '../../../../../component/Api';

export const useEvaluationDetails = (evaluationId, onBack, refreshKey = 0) => {

    const { http } = useMemo(() => Api(), []);
    const [evaluationData, setEvaluationData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const fetchEvaluationDetails = async () => {

            if (!evaluationId) {
                onBack();
                return;
            }

            try {
                setIsLoading(true);
                const response = await http.get(`/is/evaluationDetails/${evaluationId}`);

                if (response.data?.data) {
                    setEvaluationData(response.data.data);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: 'Evaluation details not found',
                        icon: 'error',
                        confirmButtonColor: '#581f37',
                    }).then(() => onBack());
                }

            } catch (error) {

                console.error('Error fetching Evaluation details:', error);

                Swal.fire({
                    title: 'Error',
                    text: 'Failed to load Evaluation details',
                    icon: 'error',
                    confirmButtonColor: '#581f37',
                }).then(() => onBack());

            } finally {
                setIsLoading(false);
            }
        };

        fetchEvaluationDetails();

    }, [evaluationId, http, onBack, refreshKey]);

    return { evaluationData, isLoading };
};